@use 'sass:math';
@import '@a-ui/core/src/styles/quarks';

.m-overlay__inner {
  width: 100%;
  max-width: calc(1.5rem * 25);
}

.m-cookie-consent {

  .m-modal__footer {
    flex-wrap: wrap;
    gap: $spacer-xs;

    .a-button:not(:first-child) {
      white-space: nowrap;

      @include at($screen-xs) {
        margin-left: 0;
      }
    }
  }
}

.m-cookie-consent__category-title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: $spacer;
  justify-content: space-between;
  width: 100%;

  h2 {
    cursor: pointer;
  }

  .u-text-right p {
    align-items: center;
    display: flex;
    min-height: 1.75rem;
  }

  .a-switch__button {
    margin-right: $spacer;

    &:before {
      left: calc(100% - $spacer);
    }

    &:after {
      left: 100%;
    }
  }
}

.m-cookie-consent__category-detail {
  overflow: hidden;
  padding-left: $spacer;

  .a-table-responsive-wrapper table {
    >tbody>tr>td,
    >tfoot>tr>td,
    >thead>tr>td {
      display: table-cell;
      vertical-align: top;
      white-space: pre-wrap;
    }

    td {
      -webkit-hyphens: auto;
      hyphens: auto;

      &:before {
        content: '';
        display: block;
      }

      &:nth-of-type(4):before {
        min-width: 12rem;
      }
    }
  }

  tr.is-condensed {
    height: var(--spacer-l);
  }
}

.m-cookie-consent--non-blocking {
  background: #fff;
  border-top: 1px solid $border-color;
  bottom: 0;
  box-shadow: 0 -$spacer 0 var(--box-shadow-color);
  max-height: 50vh;
  overflow: auto;
  position: fixed;
  width: 100%;
  z-index: layer('overlay');
}

.m-cookie-consent__content {
  @include at($screen-md) {
    display: flex;
    gap: $spacer;
  }
}

.m-modal__top-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: $spacer-xs;
  justify-content: space-between;
}

.m-cookie-consent__text {
  padding-bottom: $spacer;
}

.m-cookie-consent__buttons {
  display: flex;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: $spacer-xs;

  @include at($screen-md) {
    flex-direction: column;
    justify-content: flex-end;
  }
}
